export const OBTENER_BARRIOS = 'barrios_traer_todas';
export const ERROR = 'barrios_error';
export const LOADING = 'barrios_loading';
export const FILTRAR = 'barrios_filtrar';